import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/features/auth/store";
import React from "react";

export const GuestRoute = ({ children }: { children: React.ReactNode }) => {
  const token = useAuthStore((s) => s.token);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/app";

  if (isLoading) return null;
  if (token) return <Navigate to={from} replace />;
  return <>{children}</>;
};
